import axios from "axios";

const PROFILE_API_URL = "/api/profile";

export function getCurrentProfile() {
  return axios.get(PROFILE_API_URL).then(result => result.data);
}

export function updateCurrentProfile(updatedProfile) {
  return axios
    .post(`${PROFILE_API_URL}/save`, updatedProfile)
    .then(result => result.data);
}
